varying vec2 vUv; 
uniform sampler2D logo;
uniform float u_zoom;
uniform vec3 colorOne;
uniform vec3 colorTwo;
uniform bool u_win;

vec2 rotateCW(vec2 p, float a)
{
	mat2 m = mat2(cos(a), -sin(a), sin(a), cos(a));
	return p * m;
}
void main()
{
    vec2 ndc = (((vUv-0.5)*2.)*u_zoom);
    ndc.x *=-1.;
    vec2 rotatedUv = rotateCW(ndc, 3.14159*0.25);
    vec2 paternUv = abs(mod(((rotatedUv - vec2(0.1)) * 1.1) * 4.0 + vec2(0.5), 2.0) - 1.0);

//     // 
    float logoMask = texture2D(logo, paternUv).x;
//     logoMask = u_win ?  clamp(logoMask, 0., 1.): clamp(logoMask, 0., 0.);
    // float rougphMask = clamp(1.-logoMask, 0., 1.);
    float rougphMask = clamp(1.-logoMask, 0.3, 0.7);

    
csm_Roughness *= rougphMask;
// si les couleurs aténués ne plaisent pas passer sur cette ligne plutot que l'autre
// csm_DiffuseColor.rgb = mix(colorTwo, colorOne, logoMask);
csm_DiffuseColor.rgb = mix(colorOne, colorTwo, rougphMask);

// csm_DiffuseColor.rgb += vec3(rougphMask);




}